<template>
    <p class="m-0 px-2 h3 font-weight-bold" :title="title">{{ title }}</p>
</template>

<script>
export default {
    name: 'BlockTitle',
    props: {
        title: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
p {
    white-space: nowrap;
}
</style>
